package org.gstechnovos.jexonplastech.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.gstechnovos.jexonplastech.components.widgets.styles.CtaButtonStyle
import org.gstechnovos.jexonplastech.components.widgets.styles.GlobalCtaContainerStyle
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.gstechnovos.jexonplastech.util.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Res
import org.gstechnovos.jexonplastech.util.animateSlideUp
import org.gstechnovos.jexonplastech.util.rememberScrollVisibility
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

// ==========================================
// DATA MODEL
// ==========================================

// Defines the strict data contract this widget requires
data class GlobalCtaData(
    val headline: String, val description: String, val buttonText: String, val buttonPath: String
)

// ==========================================
// COMPONENT
// ==========================================

// The data parameter is now fully required with no defaults
@Composable
fun GlobalCtaWidget(data: GlobalCtaData) {
    val breakpoint = LocalBreakpoint.current
    val isDesktop = breakpoint >= Res.Breakpoints.LG
    val palette = ColorMode.current.toSitePalette()

    val (isVisible, visibilityRef) = rememberScrollVisibility(threshold = 0.2)

    Column(
        modifier = GlobalCtaContainerStyle.toModifier().padding(
            topBottom = if (isDesktop) 100.px else 60.px, leftRight = 5.percent
        ), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Div(
            attrs = Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column)
                .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center).toAttrs {
                    ref { element ->
                        visibilityRef(element)
                        onDispose {}
                    }
                }) {
            Column(
                modifier = Modifier.maxWidth(800.px).animateSlideUp(isVisible, delayMs = 0),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                // Headline
                SpanText(
                    text = data.headline,
                    modifier = Modifier.color(palette.custom.white).fontSize(if (isDesktop) 42.px else 32.px)
                        .fontWeight(FontWeight.Bold).margin(bottom = 20.px).textAlign(TextAlign.Center).lineHeight(1.2)
                )

                // Description
                SpanText(
                    text = data.description,
                    modifier = Modifier.color(palette.custom.white.toRgb().copyf(alpha = 0.85f))
                        .fontSize(if (isDesktop) 20.px else 16.px).lineHeight(1.6).margin(bottom = 40.px)
                        .textAlign(TextAlign.Center)
                )

                // Dynamic CTA Button
                Link(
                    path = data.buttonPath, text = data.buttonText, modifier = CtaButtonStyle.toModifier()
                )
            }
        }
    }
}